.transcriptDisplay {
  max-height: 300px;
  padding: 1rem;
  overflow-y: scroll;
  border: 1px solid var(--blue-700);
  border-radius: 0.5rem;
}

.episodeDetails {
  color: var(--blue-700);
  border-top: none !important;
}

.detailLabel {
  margin-right: 0.25rem;
  font-weight: bold;
}

.detailsList {
  font-size: 14px;
}
